import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { CamionesService } from './../../../../../../../services/API/camiones/camiones.service';
import { MaterialesService } from './../../../../../../../services/API/materiales/materiales.service';
import { ScaleCropperComponent } from '../scale-cropper/scale-cropper.component';

@Component({
  selector: 'app-edit-scale',
  templateUrl: './edit-scale.component.html',
  styleUrls: ['./edit-scale.component.css'],
  standalone: false
})
export class EditScaleComponent implements OnInit {
  form: UntypedFormGroup;
  name: string = "";
  description: string = "";
  active: boolean = true;
  defaultIdCamion: number | null = null;
  defaultIdMaterial: number | null = null;
  camiones: any[] = [];
  materiales: any[] = [];

  constructor(
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditScaleComponent>,
    private dialog: MatDialog,
    private camionesService: CamionesService,
    private materialesService: MaterialesService,
  ) { }

  ngOnInit(): void {
    this.name = this.data['name'];
    this.description = this.data['description'];
    this.active = this.data['active'] === 'true' || this.data['active'] === true;
    this.defaultIdCamion = this.parseNullableId(this.data['default_id_camion']);
    this.defaultIdMaterial = this.parseNullableId(this.data['default_id_material']);

    this.form = this.fb.group({
      name: [this.name, [Validators.required, Validators.minLength(1), Validators.maxLength(124)]],
      description: [this.description, [Validators.maxLength(512)]],
      active: [this.active, [Validators.required]],
      default_id_camion: [this.defaultIdCamion],
      default_id_material: [this.defaultIdMaterial],
      crop_x: [this.data['crop_x'] ?? null],
      crop_y: [this.data['crop_y'] ?? null],
      crop_w: [this.data['crop_w'] ?? null],
      crop_h: [this.data['crop_h'] ?? null],
    });

    this.camionesService.getCamiones('true').subscribe((result: any) => {
      this.camiones = result || [];
    });
    this.materialesService.getMateriales('Pesaje').subscribe((result: any) => {
      this.materiales = result || [];
    });
  }

  private parseNullableId(value: unknown): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    const parsed = parseInt(String(value), 10);
    return isNaN(parsed) ? null : parsed;
  }

  save() {
    const { value, valid } = this.form;
    if (valid) {
      this.dialogRef.close(value);
    }
  }

  openCropper(): void {
    const scaleId = Number(this.data['id'] ?? this.data['scaleId'] ?? this.data['idScale'] ?? 0);
    if (!scaleId) {
      return;
    }

    const ref = this.dialog.open(ScaleCropperComponent, {
      width: '95%',
      maxWidth: '900px',
      data: { scaleId, current: this.readRect() },
    });
    ref.afterClosed().subscribe((result: { rect?: { x: number; y: number; w: number; h: number } } | null) => {
      if (!result?.rect) {
        return;
      }
      this.form.patchValue({
        crop_x: result.rect.x,
        crop_y: result.rect.y,
        crop_w: result.rect.w,
        crop_h: result.rect.h,
      });
    });
  }

  private readRect(): { x: number; y: number; w: number; h: number } | null {
    const x = this.form.get('crop_x')?.value;
    const y = this.form.get('crop_y')?.value;
    const w = this.form.get('crop_w')?.value;
    const h = this.form.get('crop_h')?.value;
    if (x == null || y == null || w == null || h == null) {
      return null;
    }
    return { x: Number(x), y: Number(y), w: Number(w), h: Number(h) };
  }

  close() {
    this.dialogRef.close();
  }
}
